import React from 'react';
import { Table, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TablaEmpresasYaBorradas = ({
    candidatasPaginadas,
    cargando,
    formatearFechaLarga,
    formatearFechaCorta,
    copiarAlPortapapeles,
    estatusBorrado = 3
}) => {
    const esNoBorradas = estatusBorrado === 2;

    return (
        <div className="table-responsive bg-white">
            <Table striped hover className="fs--1 mb-0 align-middle text-nowrap">
                <thead className="bg-200 text-900">
                    <tr>
                        <th className="ps-3">ID Licencia</th>
                        <th>Empresa</th>
                        <th>Tipo Licencia</th>
                        <th>{esNoBorradas ? 'Servidor / BD Programada' : 'Servidor / BD Borrada'}</th>
                        <th>{esNoBorradas ? 'Fecha Programación' : 'Fecha de Borrado'}</th>
                        <th>BD y Servidor Vigente</th>
                        <th style={{ minWidth: '320px' }}>{esNoBorradas ? 'Motivo de No Borrado' : 'Motivo / Estatus'}</th>
                        <th className="pe-3">UUID Empresa</th>
                    </tr>
                </thead>
                <tbody>
                    {candidatasPaginadas.length > 0 ? (
                        candidatasPaginadas.map((row, idx) => (
                            <tr key={row.idLicencia || row.idProgramacion || idx}>
                                <td className="ps-3">
                                    <Link to={"/licencias/detalle/" + row.idLicencia}>
                                        <strong>{row.idLicencia}</strong>
                                    </Link>
                                </td>
                                <td>
                                    <span className="d-inline-block text-truncate fs--1 text-800 fw-semi-bold" style={{ maxWidth: '220px' }}>
                                        {row.vNombreEmpresa || 'Sin Nombre'}
                                    </span>
                                </td>
                                <td>
                                    <Badge
                                        bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'}
                                        className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}
                                    >
                                        {row.vTipoLicencia || 'Desconocido'}
                                    </Badge>
                                </td>
                                <td>
                                    <div>
                                        <div className="text-700 fs--2">{row.vServer || 'N/A'}</div>
                                        <div className="text-700 fs--2 fw-semi-bold">{row.vDatabase || 'N/A'}</div>
                                    </div>
                                </td>
                                <td>
                                    <span className="fs--1 text-700">
                                        {formatearFechaLarga(esNoBorradas ? (row.dFechaProgramacion || row.dFechaAgregada) : (row.dFechaBorrado || row.dFechaProgramacion))}
                                    </span>
                                </td>
                                <td>
                                    {row.bTieneLicenciaVigente ? (
                                        <div className="p-1 px-2 border border-warning rounded bg-white">
                                            <Badge bg="soft-warning" className="text-warning mb-1">
                                                Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                            </Badge>
                                            <div className="text-800 fs--2"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                            <div className="text-800 fs--2"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                            {row.dFinLicenciaVigente && (
                                                <div className="text-600 fs--2">Vence: {formatearFechaCorta(row.dFinLicenciaVigente)}</div>
                                            )}
                                        </div>
                                    ) : (
                                        <Badge bg="soft-secondary" className="text-secondary">
                                            Sin licencia vigente
                                        </Badge>
                                    )}
                                </td>
                                <td style={{ whiteSpace: 'normal', minWidth: '320px', maxWidth: '480px', wordBreak: 'break-word' }}>
                                    {esNoBorradas ? (
                                        <span className="fs--2 text-danger fw-semi-bold d-inline-block" style={{ lineHeight: 1.4 }} title={row.vMotivo || 'Cuenta con licencia vigente'}>
                                            <i className="fas fa-ban me-1"></i>
                                            {row.vMotivo || 'Cuenta con licencia vigente'}
                                        </span>
                                    ) : (
                                        <span className="fs--2 text-success fw-semi-bold d-inline-block" style={{ lineHeight: 1.4 }} title={row.vMotivo || 'Borrado exitoso'}>
                                            <i className="fas fa-check-circle me-1"></i>
                                            {row.vMotivo || 'Borrado exitoso'}
                                        </span>
                                    )}
                                </td>
                                <td className="pe-3">
                                    <span
                                        className="text-700 fs--2 font-monospace cursor-pointer"
                                        onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                        title="Haz clic para copiar UUID"
                                    >
                                        {row.vUUIDEmpresa || 'N/A'}
                                    </span>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={8} className="text-center py-4 text-muted fs--1">
                                {cargando ? 'Cargando datos...' : (esNoBorradas ? 'No hay registros de bases de datos omitidas o con error.' : 'No hay bases de datos borradas registradas.')}
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default TablaEmpresasYaBorradas;
